import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import "./App.css";

// USER PAGE
import LoginUser from "./view/user/pages/LoginUser";
import Registrasi from "./view/user/pages/Registrasi";
import LupaPassword from "./view/user/pages/LupaPassword";
import ValidasiPembayaran from "./view/user/pages/ValidasiPembayaran";
import ValidasiPembayaranTunggu from "./view/user/pages/ValidasiPembayaranTunggu";
import ValidasiBiodata from "./view/user/pages/ValidasiBiodata";
import ValidasiBerkas from "./view/user/pages/ValidasiBerkas";
import ValidasiBerkasTunggu from "./view/user/pages/ValidasiBerkasTunggu";

import UserBeranda from "./view/user/pages/UserBeranda";
import UserPassword from "./view/user/pages/UserPassword";
import UserProfile from "./view/user/pages/UserProfile";
import UserKehadiran from "./view/user/pages/UserKehadiran";
import UserMateriDiklat from "./view/user/pages/UserMateriDiklat";
import UserMateriDiklatSatu from "./view/user/pages/UserMateriDiklatSatu";
import UserSoal from "./view/user/pages/UserSoal";
import UserSoalPretest from "./view/user/pages/UserSoalPretest";
import UserSoalPretestMulai from "./view/user/pages/UserSoalPretestMulai";
import UserNilai from "./view/user/pages/UserNilai";
import UserNilaiKognitif from "./view/user/pages/UserNilaiKognitif";
import UserNilaiAfektif from "./view/user/pages/UserNilaiAfektif";
import UserPembayaran from "./view/user/pages/UserPembayaran";
import UserStatusKelulusan from "./view/user/pages/UserStatusKelulusan";
import UserStatusProses from "./view/user/pages/UserStatusProses";
import UserStatusTidakLulus from "./view/user/pages/UserStatusTidakLulus";
import PageNotFound from "./view/user/pages/PageNotFound";
import ProtectedRoutes from "./ProtectedRoutes";
require('dotenv').config();

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact component={LoginUser}></Route>
          <Route path="/registrasi" exact component={Registrasi}></Route>
          <ProtectedRoutes path="/lupa-password" exact component={LupaPassword}></ProtectedRoutes>
          <ProtectedRoutes path="/user/validasi-pembayaran" exact tahap={0} component={ValidasiPembayaran}></ProtectedRoutes>
          <ProtectedRoutes path="/user/validasi-pembayaran-tunggu" exact component={ValidasiPembayaranTunggu}></ProtectedRoutes>
          <ProtectedRoutes path="/user/validasi-biodata" exact tahap={2} component={ValidasiBiodata}></ProtectedRoutes>
          <ProtectedRoutes path="/user/validasi-berkas" exact tahap={4} component={ValidasiBerkas}></ProtectedRoutes>
          <ProtectedRoutes path="/user/validasi-berkas-tunggu" exact component={ValidasiBerkasTunggu}></ProtectedRoutes>
          <ProtectedRoutes path="/user/beranda" exact component={UserBeranda}></ProtectedRoutes>
          <ProtectedRoutes path="/user/password" exact component={UserPassword}></ProtectedRoutes>
          <ProtectedRoutes path="/user/profil" exact component={UserProfile}></ProtectedRoutes>
          <ProtectedRoutes path="/user/kehadiran" exact component={UserKehadiran}></ProtectedRoutes>
          <ProtectedRoutes path="/user/materi-diklat" exact component={UserMateriDiklat}></ProtectedRoutes>
          <ProtectedRoutes path="/user/materi-diklat/1" exact component={UserMateriDiklatSatu}></ProtectedRoutes>
          <ProtectedRoutes path="/user/soal" exact component={UserSoal}></ProtectedRoutes>
          <ProtectedRoutes path="/user/soal/pretest" exact component={UserSoalPretest}></ProtectedRoutes>
          <ProtectedRoutes path="/user/soal/pretest/mulai" exact component={UserSoalPretestMulai}></ProtectedRoutes>
          <ProtectedRoutes path="/user/nilai" exact component={UserNilai}></ProtectedRoutes>
          <ProtectedRoutes path="/user/nilai/kognitif" component={UserNilaiKognitif}></ProtectedRoutes>
          <ProtectedRoutes path="/user/nilai/afektif" component={UserNilaiAfektif}></ProtectedRoutes>
          <ProtectedRoutes path="/user/status-pembayaran" exact component={UserPembayaran}></ProtectedRoutes>
          <ProtectedRoutes path="/user/status-kelulusan" exact component={UserStatusKelulusan}></ProtectedRoutes>
          <ProtectedRoutes path="/user/status-kelulusan-proses" exact component={UserStatusProses}></ProtectedRoutes>
          <ProtectedRoutes path="/user/status-kelulusan-tidak-lulus" exact component={UserStatusTidakLulus}></ProtectedRoutes>

          <Route path="/404" component={PageNotFound}></Route>
          <Redirect to="/404" />
        </Switch>
      </Router>
    );
  }
}

export default App;
